import React, { useState } from 'react';
import { Box, Typography, Button, Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface WebhookUrlDisplayProps {
  url: string;
  onHelpClick: () => void;
}

export const WebhookUrlDisplay: React.FC<WebhookUrlDisplayProps> = ({
  url,
  onHelpClick,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy webhook URL:', err);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="body2" fontWeight="medium">
          Webhook URL
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Where do I add this?
        </Typography>
        <Tooltip title="Learn where to add the webhook URL in JobNimbus">
          <IconButton size="small" onClick={onHelpClick}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {url}
      </Typography>
      <Button
        size="small"
        onClick={handleCopy}
        sx={{ mt: 1 }}
        variant="outlined"
      >
        {copied ? 'Copied!' : 'Copy Webhook URL'}
      </Button>
    </>
  );
};
